import { connect } from 'react-redux';

import Test from './test';
import { onLoadTests, selectTest, onSubmitAnswer, onSubmitTest, onRestart, selectResult } from '../../reducers/test.reducers';
import { onLoadCard, onLoadCardSucceeded, onExportContent } from '../../reducers/course.reducers';

const mapStateToProps = state => ({
  isLoading: state.tests.isLoadingQuestions,
  test: state.tests.selectedTest,
  questions: state.tests.questions,
  runStartedAt: state.tests.runStartedAt,
  correctAnswersCount: state.tests.correctAnswersCount,
  completed: state.tests.selectedTest && !!state.tests.selectedTest.endDate,
  tests: state.tests.previewTests,
  card: state.courses.cardForModal,
  testRun: state.tests.testRun,
  exams: state.tests.exams,
});

const mapDispatchToProps = dispatch => ({
  loadTest: (test) => {
    dispatch(selectTest(test));
  },
  loadResult: (test) => {
    dispatch(selectResult(test));
  },
  onSubmitAnswer: (question, answersTicked, testRunId) => {
    dispatch(onSubmitAnswer({ question, answersTicked, testRunId }));
  },
  onSubmitTest: () => dispatch(onSubmitTest()),
  onRestart: () => dispatch(onRestart()),
  onLoadCard: options => dispatch(onLoadCard(options)),
  onCloseLinkedCard: () => dispatch(onLoadCardSucceeded({ card: null })),
  onExportContent: url => dispatch(onExportContent(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Test);



// WEBPACK FOOTER //
// ./src/app/main/test/test.container.js